export const formatDatePrimeNG = (
  date: Date | string,
  format: string,
): string => {
  if (!date) return '';

  const d = new Date(date);
  if (isNaN(d.getTime())) return '';

  const day = d.getDate().toString().padStart(2, '0');
  const month = (d.getMonth() + 1).toString().padStart(2, '0');
  const yearFull = d.getFullYear().toString();

  return format.replace(/dd/, day).replace(/mm/, month).replace(/yy/, yearFull);
};
